import { render, staticRenderFns } from "./base-mock.vue?vue&type=template&id=4af8a361"
import script from "./base-mock.vue?vue&type=script&lang=js"
export * from "./base-mock.vue?vue&type=script&lang=js"
import style0 from "./base-mock.vue?vue&type=style&index=0&id=4af8a361&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports